import React from 'react'

import '../styles/notLoseSubscribtion.scss'

const NotLoseSubscribtion = () => (
  <a
    href="https://arzamas.academy/radio/announcements/podpiska"
    rel="noopener noreferrer"
    target="_blank"
    className="account-not-lose-subscribtion">
    <div className="account-not-lose-subscribtion__content">
      Что сделать, чтобы не потерять подписку после ухода Visa и Mastercard из России?{' '}
      <span>
        Инструкция <span>здесь</span>.
      </span>
    </div>
  </a>
)

export default NotLoseSubscribtion
